interface IAuthState {
  jwt: string | boolean;
  user: any;
  identifier?: string;
  password?: string;
}

const initState = {
  jwt: false,
  user: false,
};

export default function authReducer(state: IAuthState = initState, action: any): IAuthState {
  if (action.type === 'JWT_STORE') {
    return { ...state, jwt: action.payload };
  }

  if (action.type === 'UPDATE_IDENTIFIER') {
    return { ...state, identifier: action.payload };
  }

  if (action.type === 'UPDATE_PASSWORD') {
    return { ...state, password: action.payload };
  }

  if (action.type === 'UPDATE_USER') {
    return { ...state, user: action.payload };
  }

  if (action.type === 'LOGOUT') {
    return { ...state, user: false, jwt: false };
  }

  return state;
}
